<template>
  <div>
    <!-- <div
      style="width:auto;font-size: 40px;text-align: left;padding: 0 10px;color:rgb(4, 134, 248);"
    >
      欢迎登录 多易禾-管理后台
    </div> -->
    <div id="myEchart" :style="[{ height: height + 'px' }]"></div>
    <!-- <h1 style="width:auto;font-size: 40px;text-align: left;padding: 0 10px;color:rgb(4, 134, 248)"></h1> -->
  </div>
</template>
<script>
import * as echarts from "echarts";
import "echarts-wordcloud";
export default {
  name: "welcome",
  data() {
    return {
      width: "",
      height: ""
    };
  },
  mounted() {
    this.initEchart();
  },
  watch: {
    innerWH: {
      handler(newinner, oldinner) {
        this.height = newinner.innerHeight - 135;
        /* if (newinner.innerHeight < 700) {
          this.height = newinner.innerHeight - 110;
          console.log(this.scroll_height);
        } else {
          this.scroll_height = newinner.innerHeight - 130;
          console.log(this.scroll_height);
        } */
        // this.SETMAINh(this.scroll_height);
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    innerWH() {
      return this.$store.state.resolution.innerWH;
    }
  },
  methods: {
    initEchart() {
      const echartDom = document.getElementById("myEchart");
      const myChart = echarts.init(echartDom);

      const option = {
        series: [
          {
            maskImage: this.maskImage,
            type: "wordCloud",
            shape: "circle",
            keepAspect: false,
            left: "center",
            top: "center",
            width: "100%",
            height: "100%",
            right: null,
            bottom: null,
            sizeRange: [16, 100],
            rotationRange: [-90, 90],
            rotationStep: -45,
            gridSize: 20,
            drawOutOfBound: false,
            layoutAnimation: true,
            textStyle: {
              fontFamily: "sans-serif",
              fontWeight: "bold",
              color: function() {
                return (
                  "rgb(" +
                  [0, 0, Math.round(Math.random() * 255)].join(",") +
                  ")"
                );
              }
            },
            emphasis: {
              // focus: 'self',
              textStyle: {
                textShadowBlur: 20,
                textShadowColor: "rgb(4, 134, 248)"
              }
            },
            //data属性中的value值却大，权重就却大，展示字体就却大
            data: [
              { name: "欢迎登录多易禾管理后台", value: 13 },
              { name: "多易禾", value: Math.round(Math.random() * 10) },
              { name: "多易禾", value: Math.round(Math.random() * 10) },
              { name: "多易禾", value: Math.round(Math.random() * 10) },
              { name: "多易禾", value: Math.round(Math.random() * 10) },
              { name: "多易禾", value: Math.round(Math.random() * 10) },
              { name: "多易禾", value: Math.round(Math.random() * 10) },
              { name: "多易禾", value: Math.round(Math.random() * 10) },
              { name: "多易禾", value: Math.round(Math.random() * 10) },
              { name: "多易禾", value: Math.round(Math.random() * 10) },
              { name: "多易禾", value: Math.round(Math.random() * 10) },
              { name: "多易禾", value: Math.round(Math.random() * 10) },
              { name: "多易禾", value: Math.round(Math.random() * 10) },
              { name: "多易禾", value: Math.round(Math.random() * 10) },
              { name: "多易禾", value: Math.round(Math.random() * 10) },
              { name: "多易禾", value: Math.round(Math.random() * 10) },
              { name: "多易禾", value: Math.round(Math.random() * 10) },
              { name: "多易禾", value: Math.round(Math.random() * 10) },
              { name: "多易禾", value: Math.round(Math.random() * 10) },
              { name: "多易禾", value: Math.round(Math.random() * 10) },
              { name: "多易禾", value: Math.round(Math.random() * 10) },
              { name: "多易禾", value: Math.round(Math.random() * 10) },
              { name: "多易禾", value: Math.round(Math.random() * 10) },
              { name: "多易禾", value: Math.round(Math.random() * 10) },
              { name: "多易禾", value: Math.round(Math.random() * 10) },
              { name: "多易禾", value: Math.round(Math.random() * 10) },
              { name: "多易禾", value: Math.round(Math.random() * 10) },
              { name: "多易禾", value: Math.round(Math.random() * 10) },
              { name: "多易禾", value: Math.round(Math.random() * 10) },
              { name: "多易禾", value: Math.round(Math.random() * 10) },
              { name: "多易禾", value: Math.round(Math.random() * 10) },
              { name: "多易禾", value: Math.round(Math.random() * 10) },
              { name: "多易禾", value: Math.round(Math.random() * 10) }
            ]
          }
        ]
      };
      option && myChart.setOption(option);
      //随着屏幕大小调节图表
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    }
  }
};
</script>
<style scoped lang="less">
#myEchart {
  // width: 100%;
  min-width: calc(100vw - 230px);
  height: 500px;
  // background-color: rgb(245, 159, 159);
}
</style>
